<template>
  <a-card>
    <div class="main-panel" style="min-height: 800px">

      <div class="main-content-wrap">
        <div class="main-operation-wrap">
          <a-form-model :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" :colon="false">
            <a-row :gutter="20">
              <a-col :span="4">
                <a-form-model-item label="快递单号">
                  <a-input v-model="form.sendOrder" auto-complete="off" placeholder="请输入运输单号" clearable></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="4">
                <a-form-model-item label="IFS单号">
                  <a-input v-model="form.ifsNo" auto-complete="off" placeholder="请输入IFS单号" clearable></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="4">
                <a-form-model-item label="WMS单号">
                  <a-input v-model="form.WMSNo" auto-complete="off" placeholder="请输入运输单号" clearable></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="4">
                <a-form-model-item label="处理状态" prop="">
                  <a-select v-model="form.isDeal" placeholder="请输入订单状态" clearable>
                    <a-select-option
                      v-for="item in dealList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item label="日期">
                  <a-range-picker
                    style="width: 100%"
                    :show-time="{ format: 'HH:mm:ss' }"
                    format="YYYY-MM-DD HH:mm:ss"
                    :placeholder="['Start Time', 'End Time']"
                    v-model="form.time"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="2">
                <a-form-model-item label=" ">
                  <a-button type="primary" @click="search">搜索</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>

          </a-form-model>
        </div>
        <a-row>
          <a-col :span="24" class="table-style">
            <a-table
              row-key="id"
              :loading="table.loading"
              :data-source="table.data"
              :default-sort="table.sort"
              :pagination="table.pagination"
              @change="handleTableChange"
              ref="table.dataRef">
              <a-form-model
                slot="expandedRowRender"
                slot-scope="record"
                :label-col="{ span: 7 }"
                :wrapper-col="{ span: 16 }">
                <a-form-model-item label="wmsNo">
                  <span>{{ record.order.wmsNo }}</span>
                </a-form-model-item>
                <a-form-model-item label="ifsNo">
                  <span>{{ record.order.ifsNo }}</span>
                </a-form-model-item>
                <a-form-model-item label="快递单号">
                  <span>{{ record.order.orderNo }}</span>
                </a-form-model-item>
                <a-form-model-item label="发货时间">
                  <span>{{ record.order.deliveryAt }}</span>
                </a-form-model-item>
                <a-form-model-item label="收货地址">
                  <span>{{ record.order.receiveAddress }}</span>
                </a-form-model-item>
                <a-form-model-item label="发货地">
                  <span>{{ record.order.sendCity }}</span>
                </a-form-model-item>
              </a-form-model>
              <!--              <a-table-column type="expand">-->
              <!--                <template slot-scope="text, record">-->
              <!--                  <a-table-column-->
              <!--                    :sorter="true"-->
              <!--                    key="record.order.ifsNo"-->
              <!--                    data-index="record.order.ifsNo" title="wmsNo" width="120">-->
              <!--                  </a-table-column>-->
              <!--                  <a-form-model class="demo-table-expand">-->
              <!--                    <a-form-model-item label="wmsNo">-->
              <!--                      <span>{{ props.row.order.wmsNo }}</span>-->
              <!--                    </a-form-model-item>-->
              <!--                    <a-form-model-item label="ifsNo">-->
              <!--                      <span>{{ props.row.order.ifsNo }}</span>-->
              <!--                    </a-form-model-item>-->
              <!--                    <a-form-model-item label="快递单号">-->
              <!--                      <span>{{ props.row.order.orderNo }}</span>-->
              <!--                    </a-form-model-item>-->
              <!--                    <a-form-model-item label="发货时间">-->
              <!--                      <span>{{ props.row.order.deliveryAt }}</span>-->
              <!--                    </a-form-model-item>-->
              <!--                    <a-form-model-item label="收货地址">-->
              <!--                      <span>{{ props.row.order.receiveAddress }}</span>-->
              <!--                    </a-form-model-item>-->
              <!--                    <a-form-model-item label="发货地">-->
              <!--                      <span>{{ props.row.order.sendCity }}</span>-->
              <!--                    </a-form-model-item>-->
              <!--                  </a-form-model>-->
              <!--                </template>-->
              <!--              </a-table-column>-->
              <!--              <a-table-column type="index" label="No." width="" align="center"-->
              <!--                              :index="table_index">-->
              <!--              </a-table-column>-->
              <a-table-column
                align="center"
                :sorter="true"
                key="order.ifsNo"
                data-index="order.ifsNo" title="ifsNo" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="order.wmsNo"
                data-index="order.wmsNo" title="wms" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :show-overflow-tooltip='true'
                :sorter="true"
                key="order.customerName"
                data-index="order.customerName" title="客户名称" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="order.expressCode"
                data-index="order.expressCode" title="运输商" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="order.warningReason"
                data-index="order.warningReason" title="预警原因" width="120">
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="order.warningReason"
                data-index="order.warningReason" title="货物状态" width="120">
                <template slot-scope="text, record">
                  <div>{{ record.order.orderStatus === 'DELIVERY' ? '出库': record.order.orderStatus === 'SEND' ? '在途':
                    record.order.orderStatus === 'COLLECT' ? '揽收': record.order.orderStatus === 'CLOSED' ? '签收': '新建'}}
                  </div>
                </template>
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="launchTime"
                data-index="launchTime" title="申请时间" width="120">
                <template slot-scope="text, record">
                  <date-time-formatter :date-time="record.launchTime"
                                       formatter="YYYY-MM-DD  HH:mm:ss"></date-time-formatter>
                </template>
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="isDeal"
                data-index="isDeal" title="是否处理" width="120">
                <template slot-scope="text, record">
                  <div>{{record.isDeal === 0 ? '未处理': '已处理'}}</div>
                </template>
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="dealTime"
                data-index="dealTime" title="处理时间" width="120">
                <template slot-scope="text, record">
                  <date-time-formatter :date-time="record.dealTime"
                                       formatter="YYYY-MM-DD  HH:mm:ss"></date-time-formatter>
                </template>
              </a-table-column>
              <a-table-column
                align="center"
                :sorter="true"
                key="dealResult"
                data-index="dealResult" title="处理结果" width="120">
                <template slot-scope="text, record">
                  <div>{{record.isDeal === 0 ? '未处理': '已处理'}}</div>
                </template>
              </a-table-column>
              <a-table-column title="操作" align="center">
                <template slot-scope="text, record">
                  <a-button type="link" @click="dealTask(record)" :disabled="record.isDeal === 1">处理</a-button>
                </template>
              </a-table-column>
              <!--              <a-table-column-->
              <!--                prop="buyStatus"-->
              <!--                label="最后承运方">-->
              <!--              </a-table-column>-->
              <!--              <a-table-column-->
              <!--                prop="createAt"-->
              <!--                label="最后绑定时间">-->
              <!--              </a-table-column>-->
              <!--              <a-table-column-->
              <!--                prop="updateAt"-->
              <!--                label="最后定位时间">-->
              <!--              </a-table-column>-->
              <!--              <a-table-column-->
              <!--                prop="date"-->
              <!--                label="操作">-->
              <!--                <template slot-scope="text, record">-->
              <!--                  <a-button type="link" v-if="record.status === 0 && record.order.orderStatus !== 'CLOSED'"-->
              <!--                             @click="changeExpediting(record.id)" v-has="'EXPECTING-DEAL'">去处理-->
              <!--                  </a-button>-->
              <!--                  <a-button type="link" v-else-if="record.status === 1 && record.order.orderStatus !== 'CLOSED'"-->
              <!--                             v-has="'EXPECTING-DEAL'">处理中-->
              <!--                  </a-button>-->
              <!--                  <a-button type="link" v-else-if=" record.order.orderStatus === 'CLOSED'" v-has="'EXPECTING-DEAL'">-->
              <!--                    已完成-->
              <!--                  </a-button>-->
              <!--                </template>-->
              <!--              </a-table-column>-->
            </a-table>
          </a-col>
        </a-row>
      </div>
    </div>
    <!--    <a-modal v-model="visible" width="600px">-->
    <!--      <order-salesman :order-id="form.data.orderId" :on-cancel-handler="onFormCancel"-->
    <!--                      :on-save-handler="onFormSave"></order-salesman>-->
    <!--    </a-modal>-->

  </a-card>
</template>

<script>
import {getInsideData, changeStatus} from '../api/insideDeal';
import DateTimeFormatter from '../components/DateTimeFormatter';
import moment from "moment";


async function findData() {
  const timeScope = this.form.time && this.form.time.length === 2
    ? this.form.time : [null, null];
  let form = this.form;
  let formData = new FormData;
  if (!this.table.prop) {
    this.table.prop = 'launchTime'
  }
  // sort: this.table.sort.prop,
  //   direction: order === 'ascend' ? 'ASC' : 'DESC',
  const { order } = this.table.sort;
  formData.append('page', this.table.pagination.current);
  formData.append('size', this.table.pagination.pageSize);
  formData.append('sort', this.table.sort.prop);
  formData.append('direction', order === 'ascend' ? 'ASC' : 'DESC');
  formData.append('isDeal', form.isDeal);
  formData.append('ifsNo', form.ifsNo);
  formData.append('wmsNo', form.WMSNo);
  formData.append('orderNo', form.sendOrder);
  if (form.time.length > 1) {
    formData.append('startAt', timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null);
    formData.append('endAt', timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null);
  }
  this.table.data = [];
  const result = await getInsideData(formData);
  // this.tableData = result.data.tableData;
  // this.listQuery.total = result.data.totalCount;
  if (result.code === 1200) {
    this.table.data = result.data.tableData
    this.table.pagination.total = result.data.totalCount;
  } else if (result.code === 1404) {
    this.table.data = []
    this.table.pagination.total = 0;
  }

}

async function dealTask(record) {
  if (record.isDeal === 0) {
    const result = await changeStatus({
      id: record.id,
    });
    if (result.code === 1200) {
      // this.$message("处理成功");
      this.$message.success("处理成功");
      this.findData();
    }
  } else {
    this.$message.error("请勿重复处理");
  }
}

function handleSizeChange(val) {

  this.listQuery.size = val;
  this.findData();
}

function handleCurrentChange(val) {
  this.listQuery.page = val;
  this.findData();
}

function search() {
  this.findData();
}

function table_index(index) {
  return (this.listQuery.page - 1) * this.listQuery.size + index + 1;
}

function handleTableChange(pagination, filters, sorter) {
  this.table.pagination.current = pagination.current;
  this.table.pagination.pageSize = pagination.pageSize;
  this.table.sort = {
    prop: !sorter.prop ? 'launchTime' : sorter.prop,
    order: !sorter.order ? 'descend' : sorter.order,
  };
  this.findData();
}


export default {
  name: 'InsideDeal',
  components: {
    DateTimeFormatter
  },
  data() {
    return {
      form: {
        sendOrder: '',
        ifsNo: '',
        WMSNo: '',
        isDeal: '',
        time: []
      },
      dealList: [{
        label: '已处理',
        value: 1
      }, {
        label: '未处理',
        value: 0
      }],
      table: {
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '40', '50'],
          showTotal: (total, range) => `${ range[0] }-${ range[1] } of ${ total } items`,
        },
        sort: {
          prop: 'launchTime',
          order: 'descend',
        },
      },
      // listQuery: {
      //   page: 1,
      //   size: 5,
      //   total: 0,
      // },
    };
  },
  methods: {
    findData,
    handleSizeChange,
    handleCurrentChange,
    table_index,
    search,
    handleTableChange,
    dealTask
  },
  mounted() {
    this.findData();
  }
};
</script>

<style>
  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>
